import { FooterLogos } from "@shared/components/AuthFooter/FooterLogos/FooterLogos";
import { FooterPrivacy } from "@shared/components/AuthFooter/FooterPrivacy/FooterPrivacy";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useQualityStorySignupExperiment } from "@shared/hooks/useQualityStorySignupExperiment/useQualityStorySignupExperiment";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { DeliveryCountry } from "@unauthenticated/signupSignin/components/DeliveryCountry/DeliveryCountry";

import { footer, footerLogos, privacyPolicy } from "./StoreLandingFooter.styles";

interface Props {
  showDeliveryCountry?: boolean;
}

const StoreLandingFooter = ({ showDeliveryCountry }: Props) => {
  const { phoneLarge } = useBreakpoints();
  const isQualityStorySignupEnabled = useQualityStorySignupExperiment({ shouldLog: false });
  const { isUS } = useSharedGlobalConfig();

  const isDeliveryCountryVisible = !!showDeliveryCountry && isQualityStorySignupEnabled && isUS;

  return (
    <div css={theme => footer(theme, isDeliveryCountryVisible)}>
      <div css={!!phoneLarge.greaterThan && footerLogos}>
        <FooterLogos />
      </div>
      <div css={privacyPolicy(isDeliveryCountryVisible)}>
        <FooterPrivacy />
      </div>
      {!!isDeliveryCountryVisible && <DeliveryCountry />}
    </div>
  );
};

export { StoreLandingFooter };
